import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInfinitySelect } from '@avenir-client-web/base-infinity-select';
import {
  Dropdown,
  DropdownModule as PrimeDropdownModule,
} from 'primeng/dropdown';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, PrimeDropdownModule, FormsModule],
})
export class DropdownComponent
  extends BaseInfinitySelect
  implements OnInit, OnDestroy
{
  @Input() scrollHeight = '200px';

  @Input() virtualScroll = false;

  @Input() hasFilter = false;

  @Input() emptyMessage = $localize`default.dropdown.empty`;

  @Input() itemTemplate: TemplateRef<unknown>;

  @Input() selectedItemTemplate: TemplateRef<unknown>;

  @Input() autoDisplayFirst = true;

  @Output() valueChange = new EventEmitter<unknown>();

  @ViewChild(Dropdown, { static: true }) dropdown: Dropdown;

  override ngOnInit(): void {
    this.updateSelectedLabel();
    this.setWrapperClass('p-dropdown-virtualscroll');
    super.ngOnInit();
  }

  updateSelectedLabel(): void {
    if (this.infinityConfig) {
      const defaultLabel = this.getDefaultOptionLabel();

      this.dropdown.label = computed(() => {
        const value = this.dropdown.value ?? this.value;

        return value ? value[this.optionLabel] : defaultLabel;
      });
    }
  }

  private getDefaultOptionLabel(): string {
    let defaultOpt = {};

    if (this.infinityConfig.defaultOptions?.length > 0) {
      defaultOpt = this.infinityConfig.defaultOptions[0] as any;
    } else if (this.optionLabel?.length > 0) {
      defaultOpt = { [this.optionLabel]: '' };
    } else {
      return '';
    }

    return defaultOpt[this.optionLabel] ?? '';
  }
}
